var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.097C9 11.3054 11.2913 9 14.1695 9H19.3904C22.2695 9 24.561 11.3052 24.561 14.097V15.0867C24.561 15.7524 24.0032 16.2748 23.337 16.2748C22.6708 16.2748 22.113 15.7524 22.113 15.0867V14.097C22.113 12.5727 20.8714 11.3763 19.3904 11.3763H14.1695C12.6898 11.3763 11.448 12.5725 11.448 14.097V25.903C11.448 27.4275 12.6898 28.6237 14.1695 28.6237H19.4012C20.8761 28.6237 22.113 27.4322 22.113 25.9147V24.9144C22.113 24.2486 22.6708 23.7263 23.337 23.7263C24.0032 23.7263 24.561 24.2486 24.561 24.9144V25.9147C24.561 28.7006 22.2733 31 19.4012 31H14.1695C11.2913 31 9 28.6946 9 25.903V14.097Z",
    fill: "#9595B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8586 19.0859C18.0319 18.8418 18.2959 18.6586 18.6162 18.6586H28.8972C29.2174 18.6586 29.4814 18.8418 29.6547 19.0859C29.8284 19.3305 29.9274 19.6546 29.9274 20C29.9274 20.3455 29.8284 20.6696 29.6547 20.9142C29.4814 21.1582 29.2174 21.3415 28.8972 21.3415H18.6162C18.2959 21.3415 18.0319 21.1582 17.8586 20.9142C17.6849 20.6696 17.5859 20.3455 17.5859 20C17.5859 19.6546 17.6849 19.3305 17.8586 19.0859Z",
    fill: "#9595B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5031 15.6826C26.0091 15.1887 26.8195 15.1985 27.3134 15.7044L30.6334 19.1057C31.1188 19.6029 31.1189 20.3966 30.6336 20.8939L27.3135 24.2963C26.8198 24.8023 26.0093 24.8123 25.5033 24.3185C24.9973 23.8248 24.9873 23.0143 25.4811 22.5083L27.9286 20L25.4813 17.4928C24.9874 16.9869 24.9972 16.1764 25.5031 15.6826Z",
    fill: "#9595B1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.0acc716b.svg";
export { ForwardRef as ReactComponent };